import { observer } from 'mobx-react-lite';
import Applications from '../components/Admin/Applications';
import BannerChanges from '../components/Modals/BannerChanges';
import { useState } from 'react';
import BricksController from '../components/Admin/BricksController';

const Admin = observer(() => { 
    const [showBanner, setShowBanner] = useState(false);
    const [showApplications, setShowApplications] = useState(true);
    const [showCards, setShowCards] = useState(false);

    const resetViews = () => {
        setShowBanner(false);
        setShowApplications(false);
        setShowCards(false);
    };

    return (
        <div className='admin-container'>
            <div className='admin-form'>
                <ul style={{ display: 'flex' }}>
                    <li>
                        <button 
                            className='admin-button'
                            onClick={() => {
                                resetViews();
                                setShowApplications(true);
                            }}
                        >
                            Заявки
                        </button>
                        {/* <img src={application_ico} className='admin-img' alt='icon'/> */}
                    </li>
                    <li>
                        <button
                            className='admin-button'
                            style={{minWidth:'120px'}}
                            onClick={() => {
                                resetViews();
                                setShowBanner(true);
                            }}
                        >
                            Прайс лист
                        </button>
                        {/* <img src={banner_ico} className='admin-img' alt='icon'/> */}
                    </li>
                    <li>
                        <button
                            className='admin-button'
                            onClick={() => {
                                resetViews();
                                setShowCards(true);
                            }}
                        >
                            Товар
                        </button>
                        {/* <img src={production_ico} className='admin-img' alt='icon'/> */}
                    </li>
                </ul>

                {showBanner && <BannerChanges />}
                {showCards && (
                    <BricksController 
                        onHide={() => setShowCards(false)} 
                        onShow={() => setShowCards(true)} 
                        />
                        
                )}
                {showApplications && (
                    <Applications 
                        onHide={() => setShowApplications(false)} 
                        onShow={() => setShowApplications(true)} 
                    />
                )}
            </div>
        </div>
    );
});

export default Admin;